import EVisits from './e-visits';

export default EVisits;
